import { useTranslation } from 'react-i18next'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const OutOfPolicyModal = ({ show, onClose }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} title={t('Pedido no cubierto por la política de devoluciones')} onClose={onClose} size="l">
      <Styles.Container>
        <Text type="bodyMRegular">
          {t('Este pedido no suele estar cubierto por la política de devoluciones de su tienda.')}
        </Text>

        <Text type="bodyMRegular">{t('Es posible crear un RMA, pero deberá tratarse como un caso especial.')}</Text>

        <Text type="bodyMRegular">
          {t('Ten en cuenta que esto puede crear expectativas para futuras solicitudes del cliente.')}
        </Text>

        <Button onClick={onClose} fullWidth>
          {t('Aceptar')}
        </Button>
      </Styles.Container>
    </Modal>
  )
}

export default OutOfPolicyModal
